// src/services/gym.service.js
import { baseApi } from "./base.api";
import { API_CONFIG } from "../config/api.config";

class GymService {
  createGym(data) {
    return baseApi.post(API_CONFIG.ENDPOINTS.GYM.CREATE, data);
  }

  login(email, password) {
    return baseApi.post(API_CONFIG.ENDPOINTS.GYM.LOGIN, {
      email,
      password,
    });
  }

  getGyms() {
    return baseApi.get(API_CONFIG.ENDPOINTS.GYM.SHOW_ALL);
  }

  getMe() {
    return baseApi.get(API_CONFIG.ENDPOINTS.GYM.ME);
  }

  updateGym(id, data) {
    return baseApi.put(API_CONFIG.ENDPOINTS.GYM.UPDATE(id), data);
  }

  deleteGym(id) {
    return baseApi.delete(API_CONFIG.ENDPOINTS.GYM.DELETE(id));
  }
  getGymDashboard() {
    return baseApi.get(API_CONFIG.ENDPOINTS.GYM.GETDASHBOARD);
  }

  checkUsername(username) {
    return baseApi.get(`/gym/check-username?username=${encodeURIComponent(username)}`);
  }

  getTelegramSettings() {
    return baseApi.get(API_CONFIG.ENDPOINTS.GYM.TELEGRAM_SETTINGS);
  }

  updateTelegramSettings(data) {
    return baseApi.put(API_CONFIG.ENDPOINTS.GYM.TELEGRAM_SETTINGS, data);
  }
}

export const gymService = new GymService();
